const breakpoints = [430, 768, 1024, 1440];

const minBreakpoints = breakpoints.map((b) => `${b}px`);

export const maxBreakpoints = breakpoints.map((b) => `${b}px`);

export const minmq = minBreakpoints.map((bp) => `@media (min-width: ${bp})`);
export const maxmq = maxBreakpoints.map((bp) => `@media (max-width: ${bp})`);
